/**
 * Shared form style constants for Project 314
 * These classes ensure consistent styling across all form elements
 */

export const formStyles = {
    // Base input/select styles
    input: 'bg-[#1E1E1E] border border-[#444] rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-[#888] focus:border-[#888] h-[38px]',
    inputError:
        'bg-[#1E1E1E] border border-red-500 rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-red-500 h-[38px]',

    // Select specific styles
    select: 'bg-[#1E1E1E] border border-[#444] rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-[#888] focus:border-[#888] h-[38px]',
    selectError:
        'bg-[#1E1E1E] border border-red-500 rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-red-500 h-[38px]',

    // Textarea specific styles
    textarea:
        'bg-[#1E1E1E] border border-[#444] rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-[#888] focus:border-[#888] resize-vertical min-h-[76px]',
    textareaError:
        'bg-[#1E1E1E] border border-red-500 rounded-md px-3 py-2 text-zinc-300 w-full focus:outline-none focus:ring-1 focus:ring-red-500 resize-vertical min-h-[76px]',

    // Size variants
    sizes: {
        sm: 'py-1 text-sm',
        md: 'py-2',
        lg: 'py-3 text-lg'
    },

    // Container styles
    container: 'mb-4',
    fullWidthContainer: 'mb-4 w-full',

    // Container styles without bottom margin (for inline use like in DateTimePicker)
    containerNoMargin: '',
    fullWidthContainerNoMargin: 'w-full',

    // Label styles
    label: 'block text-sm font-medium text-zinc-200 mb-1',

    // Help text styles
    helpText: 'mt-1 text-sm text-zinc-400',

    // Error message styles
    errorText: 'mt-1 text-sm text-red-500',

    // Placeholder text color
    placeholder: 'placeholder-[#7c8083]',

    // Color constants for reuse in JS objects (for react-select etc)
    colors: {
        background: '#1E1E1E',
        border: '#444',
        borderFocus: '#888',
        text: '#d1d5db',
        placeholder: '#7c8083',
        error: '#f8564f'
    }
};
